const hours =
{
    label  : 'Définir une tranche horaire (obligatoire)',
    title  : 'Tranches Horaires'
};

export default hours ;